import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { MatDividerModule } from '@angular/material/divider';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, ValidationErrors } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { FonctionnelService } from 'src/app/core/services/fonctionnel.service';
import { DirectionService } from 'src/app/core/services/direction.service';
import { filter, switchMap, take } from 'rxjs/operators';
import { AgentsService } from 'src/app/core/services/agents.service';
import { ReferentielsService } from 'src/app/core/services/referentiels.service';
import { DateTime } from 'luxon';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
@Component({
    selector: 'app-situation-administrative-form',
    imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatStepperModule,
    MatDatepickerModule,
    MatDividerModule,
    MatAutocompleteModule,
    MatDialogModule,
    MatProgressSpinnerModule
],
    templateUrl: './situation-administrative-form.component.html',
    styleUrls: ['./situation-administrative-form.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class SituationAdministrativeFormComponent implements OnInit {
  @Input() situationAdministrativeForm: FormGroup;
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @Output() formReset = new EventEmitter<void>();
  @Output() agentSelected = new EventEmitter<any>();
  filteredOptions: any = [];
  agentsList: any[] = [];
  val_ft_agent: any = null;
  val_ft_fonction: any = null;
  directionList: any[] = [];
  listDirection: any = [];
  listPoste: any = [];
  // posteListFiltered: any = [];
  val_ft_direction: any = null;
  listService: any = [];
  val_ft_service: any = null;
  serviceList: any[] = [];
  posteList: any[] = [];
  categoriePosteList: any[] = [];
  poleList: any[] = [];
  typeContratList: any[] = [];
  val_ft_categorie_poste: any = null;
  val_ft_poste: any = null;
  val_ft_pole: any = null;
  val_ft_type_contrat: any = null;
  recrutementListFiltered: any = [];
  recrutementList: any[] = [];
  val_ft_type_renouvellement: any = null;
  loadingAgent: boolean = false;
  dateExpirationCS: any = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly directionService: DirectionService,
    private readonly fonctionnelService: FonctionnelService,
    private readonly agentsService: AgentsService,
    private readonly referentielsService: ReferentielsService,
    private readonly cdRef: ChangeDetectorRef,
    public readonly dialog: MatDialog,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit() {
    // Handle route parameters to prefill agent data
    this.route.queryParams
      .pipe(
        filter((params) => params['agentId']),
        switchMap((params) => {
          this.loadingAgent = true;
          return this.agentsService.getAgentById(params['agentId']);
        }),
        take(1)
      )
      .subscribe({
        next: (agent) => {
          if (agent) {
            this.prefillFormViaAgent(agent);
          }
          this.loadingAgent = false;
        },
        error: (err) => {
          this.loadingAgent = false;
          this.dialog.open(AlerteModalComponent, {
            width: '640px',
            data: {
              title: 'Erreur',
              content: "Impossible de charger les données de l'agent."
            }
          });
          console.error("Erreur lors du chargement de l'agent:", err);
        }
      });

    this.loadDirectionList();
    this.loadserviceDemandes();
    this.loadAgents();
    this.loadListPoste();
    this.loadListPole();
    this.loadListTypeContrat();
    this.loadListCategoriePoste();
    this.loadListTypeRecrutement();
  }

  prefillFormViaAgent(agent: any) {
    const selectedPole = agent.direction?.pole?.id;
    const categoriePoste = agent.categoriePoste;

    // rempli la date d'expiration de CS, ce champ est en lecture seule
    let dateECS = DateTime.fromISO(agent.dateExpirationCS);
    this.dateExpirationCS = dateECS.isValid ? dateECS.toFormat('dd/MM/yyyy') : '';

    // Emit the agent data for cdisation
    this.agentSelected.emit(agent);

    if (selectedPole) {
      this.situationAdministrativeForm.patchValue({
        categoriePoste: categoriePoste,
        identifiantAgent: agent.identifiant,
        grade: agent.grade,
        dateEntree: agent.dateEntree,
        posteOccupe: agent.posteOccupe,
        tauxEmploi: agent.tauxEmploi,
        fonction: agent.fonction ?? '',
        pole: selectedPole,
        direction: agent.direction,
        serviceFonctionnel: agent.serviceFonctionnel,
        typeContrat: agent.typeContrat,
        agentRemplace: agent.agentRemplace ? 'true' : 'false',
        dateFinContrat: agent.dateFinContrat,
        dateDebutContrat: agent.dateDebutContrat,
        agent: agent // Also set the agent in the form to display correctly
      });

      // Disable fields that have values, enable those without values
      // Fields to exclude from enabling/disabling logic
      const excludedFields = ['agent', 'typeRenouvellement', 'categoriePoste', 'identifiantAgent', 'grade'];

      Object.keys(this.situationAdministrativeForm.controls).forEach((controlName) => {
        const control = this.situationAdministrativeForm.get(controlName);
        if (control && !excludedFields.includes(controlName)) {
          if (control.value) {
            control.disable();
          } else {
            control.enable();
          }
        }
      });

      this.cdRef.detectChanges();
      this.val_ft_agent = agent;
      this.val_ft_fonction = agent.fonction;
      this.val_ft_direction = agent.direction;
      this.val_ft_service = agent.serviceFonctionnel;

      Object.keys(this.situationAdministrativeForm.controls).forEach((controlName) => {
        const control = this.situationAdministrativeForm.get(controlName);
        if (control && !control.value) {
          control.markAsTouched();
        }
      });
    }
  }

  onAgentSelect(event: MatAutocompleteSelectedEvent): void {
    const agent = event.option.value;
    this.prefillFormViaAgent(agent);
  }

  onSubmit() {
    if (this.situationAdministrativeForm.valid) {
      this.formSubmit.emit(this.situationAdministrativeForm);
    }
  }
  loadListTypeRecrutement() {
    this.referentielsService
      .getTypeRenouvellement()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.recrutementList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
          this.recrutementListFiltered = [...this.recrutementList];
        }
      });
  }
  filterRenouvellementList(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.recrutementList = [];
      return;
    }
    this.recrutementListFiltered = this.recrutementList.filter((type: any) => type.libelle.toLowerCase().includes(value));
    this.cdRef.detectChanges();
  }
  effaceFiltreTypeRen(event: any, controlName: string) {
    event.stopPropagation();
    this.val_ft_type_renouvellement = '';
    if (controlName != undefined && controlName != '') {
      this.situationAdministrativeForm.controls[controlName].setValue('');
      this.loadListTypeRecrutement();
    }
  }
  typeRenouvellementdisplayFn(typeRecrutement?: any): string {
    return typeRecrutement ? typeRecrutement.libelle : ' ';
  }

  validateDateRange(control: AbstractControl): ValidationErrors | null {
    const start = control.get('dateDebutContrat')?.value;
    const end = control.get('dateFinContrat')?.value;

    if (start && end && new Date(start) > new Date(end)) {
      return { invalidDateRange: true };
    }
    return null;
  }
  onReset() {
    // Enable all form controls before resetting
    // Fields to exclude from enabling/disabling logic
    const excludedFields = ['agent', 'categoriePoste', 'identifiantAgent', 'grade'];

    Object.keys(this.situationAdministrativeForm.controls).forEach((controlName) => {
      const control = this.situationAdministrativeForm.get(controlName);
      if (control && !excludedFields.includes(controlName)) {
        control.enable();
      }
    });

    this.situationAdministrativeForm.reset();
    this.formReset.emit();
  }

  verifDateSaisie = () => {
    return (control: AbstractControl): null | ValidationErrors => {
      let c_date_debut = this.situationAdministrativeForm.controls['dateEntree'].value;
      let c_date_fin = this.situationAdministrativeForm.controls['debutFinContrat'].value;

      if (!c_date_debut || !c_date_fin) {
        return null;
      }

      let dateDebut = DateTime.fromJSDate(new Date(c_date_debut)).startOf('day');
      let dateFin = DateTime.fromJSDate(new Date(c_date_fin)).startOf('day');

      if (dateDebut <= dateFin) {
        return { erreurDateDebutValid: control.value, erreurDateValidation: true };
      }
      return null;
    };
  };

  onContractDateChange() {
    const dateEntree = this.situationAdministrativeForm.get('dateEntree')?.value;
    const debutFinContrat = this.situationAdministrativeForm.get('debutFinContrat')?.value;

    this.situationAdministrativeForm.get('debutFinContrat')?.updateValueAndValidity();

    if (dateEntree && new Date(dateEntree) > new Date(debutFinContrat)) {
      this.situationAdministrativeForm.get('debutFinContrat')?.setErrors({ dateInvalide: true });
    } else {
      this.situationAdministrativeForm.get('debutFinContrat')?.setErrors(null);
    }
  }
  setOrganizationEntryDate() {
    const dateEntree = this.situationAdministrativeForm.get('dateEntree')?.value;
    const debutFinContrat = this.situationAdministrativeForm.get('debutFinContrat')?.value;

    this.situationAdministrativeForm.get('dateDepart')?.updateValueAndValidity();

    if (debutFinContrat && new Date(dateEntree) > new Date(debutFinContrat)) {
      this.situationAdministrativeForm.get('dateDepart')?.setErrors({ dateInvalide: true });
    } else {
      this.situationAdministrativeForm.get('dateDepart')?.setErrors(null);
    }
  }

  effaceFonctionFiltre(event: any, controlName: string) {
    event.stopPropagation();
    this.val_ft_fonction = '';
    if (controlName != undefined && controlName != '') {
      this.situationAdministrativeForm.controls[controlName].setValue('');
      this.loadListPoste();
    }
  }
  loadAgents() {
    this.agentsService
      .getAllAgentsDemandes('renouvellement')
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            //this.agentsList = data;
            this.agentsList = data.map((agent) => ({
              ...agent,
              direction: agent.direction || { libelle: '' },
              serviceFonctionnel: agent.serviceFonctionnel || { libelle: '' }
            }));
            this.filteredOptions = [...this.agentsList];
            this.cdRef.detectChanges();
          } else {
            console.error('la liste des agents est invalide :', data);
          }
        },
        error: (err) => {
          this.dialog.open(AlerteModalComponent, {
            width: '640px',
            data: {
              title: 'Alerte',
              content: "Il n'y a aucun agent à renouveler."
            }
          });
          console.error('Erreur lors du chargement des agents :', err);
        }
      });
  }

  loadAgentsMoi(): void {
    this.agentsService.getCurrentAgent().subscribe({
      next: (agents) => {
        this.agentsList = [agents];
      },
      error: (err) => {
        console.error('Erreur lors du chargement des agents :', err);
      }
    });
  }

  loadDirectionList() {
    this.directionService
      .getAllDirectionsDemandes()
      .pipe(take(1))
      .subscribe((data) => {
        if (data && Array.isArray(data)) {
          this.listDirection = data.filter((o: any) => o.libelle !== '');
          this.directionList = [...this.listDirection];
        } else {
          console.error('Les données reçues ne contiennent pas de résultats valides:', data);
        }
      });
  }

  loadserviceDemandes() {
    this.fonctionnelService
      .getAllServicesDemandes()
      .pipe(take(1))
      .subscribe((data) => {
        if (data && Array.isArray(data)) {
          this.listService = data.filter((o: any) => o.libelle !== '');
          this.serviceList = [...this.listService];
        } else {
          console.error('Les données reçues ne sont pas valides ou ne contiennent pas de résultats:', data);
        }
      });
  }
  loadListPoste() {
    this.referentielsService
      .getPoste()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.posteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
          // this.posteListFiltered = [...this.posteList];
        }
      });
  }
  loadListCategoriePoste() {
    this.referentielsService
      .getCategoriePoste()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.categoriePosteList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }
  trackByPoleId(index: number, pole: any): string {
    return pole.id;
  }
  loadListPole() {
    this.referentielsService
      .getPole()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.poleList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }
  loadListTypeContrat() {
    this.referentielsService
      .getTypeContrat()
      .pipe(take(1))
      .subscribe((data: any[]) => {
        if (data) {
          this.typeContratList = data.filter((o) => o.libelle && o.libelle.trim() !== '');
        }
      });
  }

  fonctionFilter(event: any) {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.posteList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');

    this.posteList = this.listPoste.filter((item: any) => item.libelle.toLowerCase().split(' ').join('').includes(filterValue));
  }
  effaceFiltreCategoriePoste(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.val_ft_categorie_poste.controls[controlName].setValue('');
    }
  }
  effaceFiltrePoste(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.val_ft_poste.controls[controlName].setValue('');
    }
  }

  effaceFiltrePole(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.val_ft_pole.controls[controlName].setValue('');
    }
  }
  effaceFiltreTypeContrat(event: any, controlName: string) {
    event.stopPropagation();
    if (controlName != undefined && controlName != '') {
      this.val_ft_type_contrat.controls[controlName].setValue('');
    }
  }

  agentFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredOptions = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.filteredOptions = this.agentsList.filter((agent: any) =>
      (agent.nom + agent.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }
  effaceAgentFiltre(event: any, controlName: string) {
    event.stopPropagation();

    if (controlName != undefined && controlName != '') {
      this.situationAdministrativeForm.controls[controlName].setValue('');
      this.loadAgents();
    }
  }

  agentdisplayFn(agent: any): string {
    return agent ? `${agent.nom} ${agent.prenom}` : '';
  }

  directionFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.directionList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.directionList = this.listDirection.filter((item: any) => item.libelle.toLowerCase().split(' ').join('').includes(filterValue));
  }
  effaceDirectionFiltre(event: any, controlName: string) {
    event.stopPropagation();
    this.val_ft_direction = '';
    if (controlName != undefined && controlName != '') {
      this.situationAdministrativeForm.controls[controlName].setValue('');
      this.loadDirectionList();
    }
  }

  directiondisplayFn(direction?: any): string {
    return direction ? direction.libelle : '';
  }
  fonctiondisplayFn(agent?: any): string {
    return agent ? agent.fonction : '';
  }
  serviceFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.serviceList = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.serviceList = this.listService.filter((element: any) => element.libelle.toLowerCase().split(' ').join('').includes(filterValue));
  }

  effaceFiltreService(event: any, controlName: string) {
    event.stopPropagation();

    if (controlName != undefined && controlName != '') {
      this.situationAdministrativeForm.controls[controlName].setValue('');
      this.loadserviceDemandes();
    }
  }
  servicedisplayFn(element?: any): any {
    return element ? element.libelle : undefined;
  }
}
